module.exports = __webpack_public_path__ + "img/95.51423ef6.jpg";